{
  "COMPOSE_REDIRECT": {
    "OPENING": "جارٍ فتح محادثة جديدة مع {email}…",
    "NO_EMAIL": "لم يتم توفير عنوان بريد إلكتروني. استخدم ?email=name@example.com",
    "CONTACT_ERROR": "تعذر العثور على جهة الاتصال الخاصة بـ {email}."
  },
  "CONVERSATION": {
    "SELECT_A_CONVERSATION": "الرجاء اختيار محادثة من قائمة المحادثات",
    "CSAT_REPLY_MESSAGE": "الرجاء تقييم المحادثة",
    "404": "عذراً، لا يمكننا العثور على المحادثة. الرجاء المحاولة مرة أخرى",
    "SWITCH_VIEW_LAYOUT": "تبديل التصميم",
    "DASHBOARD_APP_TAB_MESSAGES": "الرسائل",
    "UNVERIFIED_SESSION": "لم يتم التحقق من هوية هذا المستخدم",
    "NO_MESSAGE_1": "لا توجد رسائل بعد من العملاء في صندوق الوارد الخاص بك.",
    "NO_MESSAGE_2": " لإرسال رسالة إلى الصفحة الخاصة بك!",
    "NO_INBOX_1": "يبدو أنك لم تقم بإضافة أي صناديق بريدية بعد.",
    "NO_INBOX_2": " للبدء",
    "NO_INBOX_AGENT": "يبدو أنه لم يتم إسنادك لأي قنوات تواصل بعد. الرجاء التواصل مع المدير لإضافتك لصناديق الوارد الخاصة بقنوات التواصل",
    "SEARCH_MESSAGES": "ابحث عن رسائل في المحادثات",
    "VIEW_ORIGINAL": "View original",
    "VIEW_TRANSLATED": "View translated",
    "TRANSLATION": "ترجمة",
    "EMPTY_STATE": {
      "CMD_BAR": "لفتح قائمة الأوامر",
      "KEYBOARD_SHORTCUTS": "لعرض اختصارات لوحة المفاتيح"
    },
    "SEARCH": {
      "TITLE": "البحث في الرسائل",
      "RESULT_TITLE": "نتائج البحث",
      "LOADING_MESSAGE": "جار تجزئة البيانات...",
      "PLACEHOLDER": "اكتب أي نص للبحث في الرسائل",
      "NO_MATCHING_RESULTS": "لم يتم العثور على النتائج."
    },
    "UNREAD_MESSAGES": "الرسائل الغير مقروءة",
    "UNREAD_MESSAGE": "رسالة غير مقروءة",
    "CLICK_HERE": "اضغط هنا",
    "LOADING_INBOXES": "جار جلب صناديق الوارد",
    "LOADING_CONVERSATIONS": "جاري جلب المحادثات",
    "CANNOT_REPLY": "لا يمكنك الرد بسبب",
    "24_HOURS_WINDOW": "قيد نافذة الـ 24 ساعة",
    "NOT_ASSIGNED_TO_YOU": "لم يتم تعيين هذه المحادثة لك. هل ترغب في تعيين هذه المحادثة لنفسك؟",
    "ASSIGN_TO_ME": "إسناد لي",
    "TWILIO_WHATSAPP_CAN_REPLY": "يمكنك فقط الرد على هذه المحادثة باستخدام رسالة قالب بسبب",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "قيد نافذة الـ 24 ساعة",
    "REPLYING_TO": "أنت ترد على:",
    "REMOVE_SELECTION": "إزالة التحديد",
    "DOWNLOAD": "تحميل",
    "UNKNOWN_FILE_TYPE": "ملف غير معروف",
    "SAVE_CONTACT": "Save Contact",
    "NO_CONTENT": "No content to display",
    "COPILOT_ASSUMED_ACTIONS": {
      "TITLE": "قبل الإرسال، يُرجى تنفيذ:",
      "EXECUTE": "تنفيذ",
      "RETRY": "إعادة المحاولة",
      "CONFIRM": "هل تريد التنفيذ الآن؟",
      "CONFIRM_YES": "نعم، نفِّذ",
      "CONFIRM_NO": "إلغاء",
      "RUNNING": "جارٍ التنفيذ…",
      "DONE": "تم",
      "CLAIM_DELAYED": "ستُقدَّم بعد تسليم الطلب",
      "DEVIATIONS": {
        "CLAIM_CLOSED": "تم إنشاء شكوى جديدة {reference}، لأن {planned} مغلقة — يُرجى تعديل نص المسودة",
        "NEW_CLAIM": "تم إنشاء شكوى جديدة {reference} بدلًا من تحديث {planned} — يُرجى تعديل نص المسودة",
        "OTHER_CLAIM": "تم تحديث الشكوى {reference} بدلًا من {planned} — يُرجى تعديل نص المسودة",
        "EXISTING_CLAIM": "لم يتم إنشاء شكوى جديدة، بل تم تحديث الشكوى الحالية {reference} — يُرجى تعديل نص المسودة",
        "OTHER": "جرى الأمر بشكل مختلف عمّا افترضته المسودة — يُرجى تعديل نص المسودة"
      },
      "FAILED": "فشل",
      "UNREACHABLE": "تعذّر الوصول إلى البوت",
      "REQUEST_FAILED": "تعذّر بدء الإجراء، يُرجى المحاولة مرة أخرى.",
      "ACTIONS": {
        "CANCEL_ORDER": "إلغاء الطلب",
        "CHANGE_ORDER_PAYMENT_TO_COD": "تغيير طريقة الدفع إلى الدفع عند الاستلام",
        "CREATE_CLAIM": "تقديم شكوى",
        "CREATE_OR_UPDATE_CLAIM": "تقديم أو تحديث شكوى",
        "EXTEND_ORDER_PICKUP_DATE": "تمديد مهلة الاستلام"
      }
    },
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} has shared a contact",
      "LOCATION": "{sender} has shared a location",
      "FILE": "{sender} has shared a file"
    },
    "UPLOADING_ATTACHMENTS": "جاري رفع المرفقات...",
    "REPLIED_TO_STORY": "رد على قصتك",
    "UNSUPPORTED_MESSAGE": "This message is unsupported. You can view this message on the Facebook / Instagram app.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "هذه الرسالة غير مدعومة، يمكنك مشاهدة هذه الرسالة على تطبيق فيسبوك (Messenger).",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "هذه الرسالة غير مدعومة، يمكنك عرض هذه الرسالة على تطبيق Instagram.",
    "SUCCESS_DELETE_MESSAGE": "تم حذف الرسالة بنجاح",
    "FAIL_DELETE_MESSSAGE": "تعذر حذف الرسالة! حاول مرة أخرى",
    "NO_RESPONSE": "لا توجد استجابة",
    "RESPONSE": "Response",
    "RATING_TITLE": "التقييم",
    "FEEDBACK_TITLE": "الملاحظات",
    "REPLY_MESSAGE_NOT_FOUND": "الرسالة غير متوفرة",
    "CARD": {
      "SHOW_LABELS": "إظهار السمات",
      "HIDE_LABELS": "إخفاء السمات"
    },
    "HEADER": {
      "RESOLVE_ACTION": "حل المحادثة",
      "REOPEN_ACTION": "إعادة فتح",
      "OPEN_ACTION": "فتح",
      "OPEN": "المزيد",
      "CLOSE": "أغلق",
      "DETAILS": "التفاصيل",
      "SNOOZED_UNTIL": "غفوة حتى",
      "SNOOZED_UNTIL_TOMORROW": "تأجيل حتى الغد",
      "SNOOZED_UNTIL_NEXT_WEEK": "تأجيل حتى الأسبوع القادم",
      "SNOOZED_UNTIL_NEXT_REPLY": "تأجيل حتى الرد التالي",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "مفقود",
        "DUE": "مستحق"
      },
      "MORE": "More actions"
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "تحديد كمعلق",
      "SNOOZE_UNTIL": "غفوة",
      "SNOOZE": {
        "TITLE": "تأجيل حتى",
        "NEXT_REPLY": "الرد القادم",
        "TOMORROW": "غداً",
        "NEXT_WEEK": "الأسبوع القادم"
      },
      "RESOLVE_WITHOUT_CSAT": "Resolve without CSAT"
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "تأجيل حتى",
      "APPLY": "تأجيل",
      "CANCEL": "إلغاء"
    },
    "PRIORITY": {
      "TITLE": "الأولوية",
      "OPTIONS": {
        "NONE": "لا يوجد",
        "URGENT": "عاجل",
        "HIGH": "عالية",
        "MEDIUM": "متوسطة",
        "LOW": "منخفضة"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "لا يوجد",
        "INPUT_PLACEHOLDER": "تحديد الأولوية",
        "NO_RESULTS": "لم يتم العثور على النتائج",
        "SUCCESSFUL": "تغيير أولوية معرف المحادثة {conversationId} إلى {priority}",
        "FAILED": "تعذر تغيير الأولوية، الرجاء المحاولة مرة أخرى."
      }
    },
    "CARD_CONTEXT_MENU": {
      "OPEN_IN_NEW_TAB": "فتح في علامة تبويب جديدة",
      "COPY_LINK": "نسخ رابط المحادثة",
      "COPY_LINK_SUCCESS": "تم نسخ رابط المحادثة إلى الحافظة",
      "PENDING": "تحديد كمعلق",
      "RESOLVED": "تحديد كمحلولة",
      "MARK_AS_UNREAD": "وضع علامة كغير مقروء",
      "MARK_AS_READ": "تحديد كمقروء",
      "REOPEN": "إعادة فتح المحادثة",
      "SNOOZE": {
        "TITLE": "تأجيل",
        "NEXT_REPLY": "حتى الرد القادم",
        "TOMORROW": "حتى الغد",
        "NEXT_WEEK": "حتى الأسبوع القادم"
      },
      "ASSIGN_AGENT": "تعيين وكيل",
      "ASSIGN_LABEL": "إضافة وسم",
      "AGENTS_LOADING": "جاري جلب الوكلاء...",
      "ASSIGN_TEAM": "تعيين فريق",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "معرف المحادثة {conversationId} تم تعيينه لـ \"{agentName}\"",
          "FAILED": "تعذر تعيين الوكيل. الرجاء المحاولة مرة أخرى."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "تعيين تسمية ##{labelName} لمعرف المحادثة {conversationId}",
          "FAILED": "تعذر تعيين التسمية. الرجاء المحاولة مرة أخرى."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "الفريق المعين \"{team}\" لمعرف المحادثة {conversationId}",
          "FAILED": "تعذر تعيين الفريق. الرجاء المحاولة مرة أخرى."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "توقيع الرسالة",
      "ENABLE_SIGN_TOOLTIP": "تفعيل التوقيع",
      "DISABLE_SIGN_TOOLTIP": "تعطيل التوقيع",
      "MSG_INPUT": "زر Shift + Enter لإضافة سطر جديد. ابدأ بزر / للاختيار من الردود الجاهزة.",
      "PRIVATE_MSG_INPUT": "زر Shift + Enter لإضافة سطر جديد. سيكون هذا مرئياً للوكلاء فقط",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "لم يتم تكوين توقيع الرسالة، الرجاء تكوينه في إعدادات الملف الشخصي.",
      "CLICK_HERE": "انقر هنا للتحديث",
      "WHATSAPP_TEMPLATES": "قوالب الواتساب",
      "WHATSAPP_TEMPLATE_ONLY_INPUT": "انتهت نافذة الـ 24 ساعة في واتساب. الرجاء الرد برسالة قالب.",
      "INSERT_SIGNATURE": "Insert signature into editor",
      "SIGNATURE_PREVIEW_IMAGE": "(image signature)"
    },
    "REPLYBOX": {
      "LANGUAGE_MISMATCH": "يبدو أن ردك مكتوب بـ {draftLanguage}، لكن هذه المحادثة بـ {conversationLanguage}.",
      "TRANSLATE_DRAFT": "ترجمة",
      "REPLY": "إضافة رد",
      "PRIVATE_NOTE": "إضافة ملاحظة خاصة",
      "SEND": "إرسال",
      "CREATE": "إضافة ملاحظة",
      "INSERT_READ_MORE": "اقرأ المزيد",
      "DISMISS_REPLY": "استبعاد الرد",
      "REPLYING_TO": "الرد على:",
      "TIP_FORMAT_ICON": "عرض محرر النصوص",
      "HEADING_LEVEL": {
        "LABEL": "نمط النص",
        "NORMAL": "نص عادي",
        "H1": "عنوان 1",
        "H2": "عنوان 2",
        "H3": "عنوان 3"
      },
      "EDITOR": {
        "BOLD": "عريض",
        "ITALIC": "مائل",
        "UNDERLINE": "تسطير",
        "TEXT_COLOR": "لون النص",
        "BG_COLOR_LABEL": "لون الخلفية",
        "FONT_SIZE_LABEL": "حجم الخط",
        "FONT_SIZE": {
          "XS": "صغير",
          "SM": "صغير متوسط",
          "MD": "افتراضي",
          "LG": "كبير",
          "XL": "كبير جدًا",
          "XXL": "ضخم"
        },
        "CODE": "كود",
        "LINK": "إضافة الرابط أو إزالته",
        "CREATE_LINK": "إنشاء رابط",
        "SAVE_LINK": "حفظ",
        "CANCEL": "إلغاء",
        "LINK_PLACEHOLDER": "https://example.com",
        "UNDO": "تراجع",
        "REDO": "إعادة",
        "BULLET_LIST": "قائمة نقطية",
        "ORDERED_LIST": "قائمة مرقمة",
        "BLOCKQUOTE": "اقتباس",
        "H1": "عنوان 1",
        "H2": "عنوان 2",
        "H3": "عنوان 3",
        "IMAGE_UPLOAD": "تحميل صورة",
        "CLEAR_FORMATTING": "مسح التنسيق",
        "COLOR": {
          "RED": "أحمر",
          "YELLOW": "أصفر",
          "BLUE": "أزرق",
          "ROSE_RED": "أحمر وردي",
          "DEEP_CYAN": "سماوي غامق",
          "ORANGE": "برتقالي",
          "PISTACHIO": "فستقي",
          "PURPLE": "أرجواني",
          "FUCHSIA": "فوشي",
          "SILVER": "فضي",
          "NAVY": "كحلي",
          "OLD_PINK": "وردي داكن",
          "AQUA": "فيروزي",
          "BROWN": "بني",
          "OLIVE": "زيتوني",
          "GOLD": "ذهبي",
          "BEIGE": "بيج",
          "WINE": "نبيتي",
          "FOREST": "أخضر غابي",
          "GREEN": "أخضر",
          "BLUE_GREY": "رمادي مزرق",
          "RUBY_RED": "أحمر ياقوتي",
          "CHESTNUT_BROWN": "بني كستنائي",
          "ASH_GREY": "رمادي الرماد"
        },
        "BG_COLOR": {
          "RED": "أحمر",
          "YELLOW": "أصفر",
          "BLUE": "أزرق",
          "ROSE_RED": "أحمر وردي",
          "DEEP_CYAN": "سماوي غامق",
          "ORANGE": "برتقالي",
          "PISTACHIO": "فستقي",
          "PURPLE": "أرجواني",
          "FUCHSIA": "فوشي",
          "SILVER": "فضي",
          "NAVY": "كحلي",
          "OLD_PINK": "وردي داكن",
          "AQUA": "فيروزي",
          "BROWN": "بني",
          "OLIVE": "زيتوني",
          "GOLD": "ذهبي",
          "BEIGE": "بيج",
          "WINE": "نبيتي",
          "FOREST": "أخضر غابي",
          "GREEN": "أخضر",
          "BLUE_GREY": "رمادي مزرق",
          "RUBY_RED": "أحمر ياقوتي",
          "CHESTNUT_BROWN": "بني كستنائي",
          "ASH_GREY": "رمادي الرماد"
        }
      },
      "TIP_EMOJI_ICON": "إظهار قائمة الرموز التعبيرية",
      "TIP_ATTACH_ICON": "إرفاق الملفات",
      "TIP_AUDIORECORDER_ICON": "تسجيل الصوت",
      "TIP_AUDIORECORDER_PERMISSION": "السماح بالوصول إلى الصوت",
      "TIP_AUDIORECORDER_ERROR": "تعذر فتح الصوت",
      "DRAG_DROP": "اسحب و أسقط هنا للإرفاق",
      "START_AUDIO_RECORDING": "بدء التسجيل الصوتي",
      "STOP_AUDIO_RECORDING": "إيقاف التسجيل الصوتي",
      "": "",
      "EMAIL_HEAD": {
        "TO": "إلى",
        "ADD_BCC": "إضافة bcc",
        "CC": {
          "LABEL": "CC",
          "PLACEHOLDER": "عناوين البريد الإلكتروني مفصولة بفاصلة",
          "ERROR": "الرجاء إدخال عنوان بريد إلكتروني صحيح"
        },
        "BCC": {
          "LABEL": "BCC",
          "PLACEHOLDER": "عناوين البريد الإلكتروني مفصولة بفاصلة",
          "ERROR": "الرجاء إدخال عنوان بريد إلكتروني صحيح"
        },
        "EDIT": "Edit",
        "EXPAND": "Cc/Bcc",
        "HIDE": "Hide",
        "INCLUDE_ORIGINAL_MESSAGE": "Include original message",
        "EDIT_HEADERS": "Edit",
        "HIDE_HEADER_EDITS": "Hide edits",
        "SUBJECT": {
          "LABEL": "SUBJECT",
          "PLACEHOLDER": "Email subject",
          "RE_PREFIX": "Re:"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "متغيرات غير معرفة",
        "MESSAGE": "لديك {undefinedVariablesCount} متغيرات غير محددة في رسالتك: {undefinedVariables}. هل ترغب في إرسال الرسالة على أي حال؟",
        "CONFIRM": {
          "YES": "إرسال",
          "CANCEL": "إلغاء"
        }
      },
      "SEND_EMAIL": "Send email",
      "SEND_SMS": "Send SMS",
      "NO_SMS_INBOX": "أضف صندوق وارد SMS لإرسال ردود SMS.",
      "SEND_CHAT": "Send chat",
      "REPLY_TO_THIS": "Reply to this",
      "TIP_EXPAND_ICON": "Enlarge editor",
      "TIP_COLLAPSE_ICON": "Shrink editor",
      "COPILOT": {
        "Q": "Ask robot for help"
      }
    },
    "VISIBLE_TO_AGENTS": "ملاحظة خاصة: مرئية فقط لك ولأعضاء فريقك",
    "CHANGE_STATUS": "تم تغيير حالة المحادثة",
    "CHANGE_STATUS_FAILED": "فشل تغيير حالة المحادثة",
    "CHANGE_AGENT": "تم تغيير الوكيل الذي تم إحالة المحادثة إليه",
    "CHANGE_AGENT_FAILED": "فشل تغيير المحال إليه",
    "ASSIGN_LABEL_SUCCESFUL": "تم تعيين الوسم بنجاح",
    "ASSIGN_LABEL_FAILED": "فشل تعيين الوسم",
    "CHANGE_TEAM": "تم تغيير فريق المحادثة",
    "FILE_SIZE_LIMIT": "حجم الملف يتجاوز حد الاقصى وهو {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE}",
    "MESSAGE_ERROR": "غير قادر على إرسال هذه الرسالة، الرجاء المحاولة مرة أخرى لاحقاً",
    "SENT_BY": "أرسلت بواسطة:",
    "BOT": "رد آلي",
    "SEND_FAILED": "تعذر إرسال الرسالة! حاول مرة أخرى",
    "TRY_AGAIN": "إعادة المحاولة",
    "ASSIGNMENT": {
      "SELECT_AGENT": "اختر وكيل",
      "REMOVE": "حذف",
      "ASSIGN": "تكليف"
    },
    "CONTEXT_MENU": {
      "COPY": "نسخ",
      "REPLY_TO": "الرد على هذه الرسالة",
      "DELETE": "حذف",
      "CREATE_A_CANNED_RESPONSE": "إضافة إلى الردود الجاهزة",
      "TRANSLATE": "ترجم",
      "COPY_PERMALINK": "نسخ الرابط إلى الرسالة",
      "LINK_COPIED": "تم نسخ عنوان URL للرسالة إلى الحافظة",
      "DELETE_CONFIRMATION": {
        "TITLE": "هل أنت متأكد من أنك تريد حذف هذه الرسالة؟",
        "MESSAGE": "لا يمكنك التراجع عن هذا الإجراء",
        "DELETE": "حذف",
        "CANCEL": "إلغاء"
      },
      "FORWARD": "Foward",
      "FORWARD_ERROR": "Failed to prepare forwarded message"
    },
    "SIDEBAR": {
      "CONTACT": "جهات الاتصال",
      "COPILOT": "Copilot"
    },
    "MESSAGE_EVENT": {
      "ACTIVITY": {
        "STATUS": {
          "RESOLVED": "تم تحديث حالة المحادثة لـ\"مغلقة\" بواسطة {userName}",
          "CONTACT_RESOLVED": "تم حل المحادثة بواسطة {contactName}",
          "OPEN": "تم إعادة فتح المحادثة بواسطة {userName}",
          "PENDING": "تم تحديث حالة المحادثة لـ\"معلقة\" بواسطة {userName}",
          "SNOOZED": "تم تأجيل المحادثة بواسطة {userName}",
          "AUTO_RESOLVED": "تم وضع علامة على المحادثة كمحلولة من قبل النظام بسبب {duration} أيام من عدم النشاط",
          "SYSTEM_AUTO_OPEN": "أعاد النظام فتح المحادثة بسبب رسالة واردة جديدة.",
          "AUTO_REOPENED": "System reopened the conversation after the snooze period ended.",
          "RESOLVED_WITHOUT_CSAT": "Conversation was marked resolved by {userName} (without CSAT)",
          "AUTO_RESOLVED_INACTIVE": "Conversation was marked resolved by system due to {duration} hours of inactivity",
          "AUTO_RESOLVED_EMPTY": "Conversation was marked resolved by system due to being empty.",
          "BLOCKED_CONTACT_RESOLVED": "System resolved the conversation because the contact is blocked.",
          "KAUFLAND_TICKET_CLOSED": "قام النظام بحل المحادثة لأن التذكرة أُغلقت على Kaufland."
        },
        "PRIORITY": {
          "ADDED": "{userName} حدد الأولوية إلى {newPriority}",
          "UPDATED": "{userName} غيّر الأولوية من {oldPriority} إلى {newPriority}",
          "REMOVED": "{userName} أزال الأولوية"
        },
        "ASSIGNEE": {
          "SELF_ASSIGNED": "{userName} تم تعيينه تلقائياً لهذه المحادثة",
          "ASSIGNED": "تم إسنادها إلى {assigneeName} بواسطة {userName}",
          "REMOVED": "المحادثة غير مسندة بواسطة {userName}"
        },
        "TEAM": {
          "ASSIGNED": "تم إسنادها إلى {teamName} بواسطة {userName}",
          "ASSIGNED_WITH_ASSIGNEE": "تم تعيينه إلى {assigneeName} عبر {teamName} بواسطة {userName}",
          "REMOVED": "إلغاء التعيين من {teamName} بواسطة {userName}"
        },
        "LABELS": {
          "ADDED": "{userName} أضاف {labels}",
          "REMOVED": "{userName} أزال {labels}"
        },
        "SLA": {
          "ADDED": "{userName} أضاف سياسة مستوى الخدمة {slaName}",
          "REMOVED": "{userName} أزال سياسة مستوى الخدمة {slaName}",
          "UPDATED": "{userName} updated SLA policy {slaName}"
        },
        "MUTED": "{userName} كتم صوت المحادثة",
        "UNMUTED": "{userName} قام بإلغاء كتم المحادثة",
        "CONTACT_BLOCKED": "{userName} حظر جهة الاتصال",
        "CONTACT_UNBLOCKED": "{userName} ألغى حظر جهة الاتصال",
        "AUTO_RESOLUTION_MESSAGE": "Resolving the conversation as it has been inactive for a while. Please start a new conversation if you need further assistance.",
        "DOMAIN_BLOCKED": "{userName} blocked all contacts for a given domain",
        "DOMAIN_UNBLOCKED": "{userName} unblocked all the contacts for a given domain",
        "MOVED": "{userName} moved this conversation from inbox {sourceInboxName} to inbox {targetInboxName}",
        "MOVED_BY_ORDER": "تم النقل لأن طلبات جهة الاتصال تأتي فقط من المتجر {storeName} (آخر طلب {orderId})، ويرد روبوته في هذا الصندوق.",
        "MERGED": "{userName} merged conversation #{sourceId} into this conversation",
        "AUTOMATION_RULE_TRIGGERED": "Automation rule \"{ruleName}\" triggered",
        "AUTOMATION_SKIP_AUTO_PRIORITY": "Automation rule \"{ruleName}\" disabled automatic priority",
        "AUTOMATION_SKIP_AUTO_LABELING": "Automation rule \"{ruleName}\" disabled automatic labeling",
        "AUTOMATION_STOP_PROCESSING_RULES": "Automation rule \"{ruleName}\" stopped further rule processing",
        "AUTOMATION_ACTION_SKIPPED_AUTO_REPLY": "Sending message action was skipped for this auto-reply message",
        "AUTOMATION_SKIPPED_CONTACT_BLOCKED": "تم تخطّي الأتمتة لأن جهة الاتصال محظورة",
        "AUTOMATION_MOVE_FAILED_INCOMPATIBLE_INBOX": "تعذّر على الأتمتة \"{ruleName}\" نقل هذه المحادثة من قناة {sourceInboxName} إلى قناة {targetInboxName} لأن القناتين غير متوافقتين.",
        "AUTOMATION_MOVE_FAILED_CONTACT_EMAIL_MISSING": "تعذّر على الأتمتة \"{ruleName}\" نقل هذه المحادثة من قناة {sourceInboxName} إلى قناة {targetInboxName} لأن جهة الاتصال ليس لديها عنوان بريد إلكتروني.",
        "AUTOMATION_RULE_DISABLED_PHONE_WITHOUT_SMS": "تعذر على الأتمتة \"{ruleName}\" إرسال رسالة: لا يمكن لصندوق الوارد الهاتفي هذا إرسال SMS لأن الحساب لا يملك صندوق وارد SMS. تم إيقاف القاعدة وتلقى المسؤولون رسالة بريد إلكتروني.",
        "AUTOMATION_RULE_DISABLED_SMS_ATTACHMENTS_NOT_SUPPORTED": "تعذر على الأتمتة \"{ruleName}\" إرسال رسالة: لا يمكن إرسال المرفقات عبر SMS من صندوق الوارد هذا. تم إيقاف القاعدة وتلقى المسؤولون رسالة بريد إلكتروني.",
        "MACRO_ACTION_SKIPPED_PHONE_WITHOUT_SMS": "لم يرسل الماكرو \"{macroName}\" رسالته: لا يمكن لصندوق الوارد الهاتفي هذا إرسال SMS لأن الحساب لا يملك صندوق وارد SMS.",
        "MACRO_ACTION_SKIPPED_SMS_ATTACHMENTS_NOT_SUPPORTED": "لم يرسل الماكرو \"{macroName}\" رسالته: لا يمكن إرسال المرفقات عبر SMS من صندوق الوارد هذا.",
        "MACRO_ACTION_SKIPPED_PENDING_WITH_BOT": "لم يرسل الماكرو \"{macroName}\" رسالته: البوت يتعامل مع هذه المحادثة. افتح المحادثة أولاً.",
        "MACRO_ACTION_SKIPPED_INBOX_DELETE_REQUESTED": "لم يرسل الماكرو \"{macroName}\" رسالته: تم تعليم صندوق الوارد هذا للحذف. انقل المحادثة إلى صندوق وارد آخر أولاً.",
        "AUTOMATION_NEW_CONVERSATION_SENT": "أرسلت الأتمتة \"{ruleName}\" بريدًا إلكترونيًا إلى {contactEmail} في محادثة جديدة [#{conversationId}]({conversationPath}) في قناة {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_SOURCE": "بدأت الأتمتة \"{ruleName}\" هذه المحادثة بسبب المحادثة [#{conversationId}]({conversationPath}) في قناة {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_EMAIL_MISSING": "تعذّر على الأتمتة \"{ruleName}\" إرسال الرسالة في محادثة جديدة في قناة {inboxName} لأن جهة الاتصال ليس لديها عنوان بريد إلكتروني.",
        "AUTOMATION_NEW_CONVERSATION_SMS_SENT": "أرسلت الأتمتة \"{ruleName}\" رسالة SMS إلى {contactPhone} في محادثة جديدة [#{conversationId}]({conversationPath}) في قناة {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_PHONE_MISSING": "تعذّر على الأتمتة \"{ruleName}\" إرسال رسالة SMS في محادثة جديدة في قناة {inboxName} لأن جهة الاتصال ليس لديها رقم هاتف.",
        "AUTO_LABELING": {
          "REASONING": "Applied labels: {labels}\n{justification}"
        },
        "AUTO_PRIORITY": {
          "REASONING": "Updated priority: {reasoning}"
        },
        "SUMMARY": {
          "ROLE": {
            "AGENT": "الوكيل",
            "CUSTOMER": "العميل"
          }
        }
      },
      "VOICE": {
        "COPILOT": {
          "CALLED_EXTENSIONS": "Called extensions:",
          "CALL_COMPLETED": "Call completed",
          "EXTENSION_OUTCOMES": {
            "ANSWERED_ELSEWHERE": "تم الرد من مكان آخر، رنّ لمدة {duration}",
            "NO_ANSWER": "لم يتم الرد، رنّ لمدة {duration}",
            "REJECTED": "تم الرفض بعد الرنين لمدة {duration}"
          },
          "EXTENSION_TYPES": {
            "IVR": "IVR",
            "OPERATOR": "Operator",
            "QUEUE": "Queue",
            "RING_GROUP": "Ring Group"
          },
          "INBOUND_CALL": "Inbound call from {number} to {did}",
          "IVR_HANDLED": "Handled by IVR",
          "IVR_LABEL_NOT_FOUND": "I wanted to add label {name}, but it does not exist, please check the configuration.",
          "CALL_MISSED": "Call missed",
          "CALL_NO_ANSWER": "No answer",
          "RESOLVED_AFTER_FAILED_CALLBACKS": "تم الحل تلقائياً بعد محاولات معاودة اتصال غير ناجحة، العدد: {count}",
          "OUTBOUND_CALL": "Outbound call made by {agentName} from {did} to {number}",
          "SUMMARY_NOT_AVAILABLE": "Unable to generate summary.",
          "RECORDING_DELETED": "تم حذف تسجيل المكالمة بواسطة {name}، {date}"
        }
      }
    },
    "IMAGE_RESIZE": {
      "SMALL": "Small",
      "MEDIUM": "Medium",
      "LARGE": "Large",
      "ORIGINAL": "Original"
    },
    "SHOW_HIDDEN_MESSAGES": "Show hidden messages",
    "TRANSCRIPT": {
      "SHOW": "Show full transcript",
      "HIDE": "Hide full transcript",
      "DOWNLOAD": "Download transcript",
      "COPY": "Copy transcript"
    },
    "INVISIBLE_TO_CUSTOMER": "غير مرئي للعميل",
    "SENT_VIA_EMAIL": "أُرسلت إلى جهة الاتصال عبر البريد الإلكتروني أيضًا ({time})",
    "API_HOURS_WINDOW": "You can only reply to this conversation within {hours} hours",
    "FACEBOOK_CANNOT_REPLY": "If you need to continue this conversation, ",
    "PENDING_WITH_BOT_BANNER": "This conversation is being handled by AI bot. If you want to reply, open the conversation first.",
    "INBOX_DELETE_REQUESTED_BANNER": "تم تعليم صندوق الوارد هذا للحذف، لذا لن تصل إجابة العميل أبدًا. انقل المحادثة إلى صندوق وارد آخر للرد.",
    "OPEN_CONVERSATIONS_BANNER": {
      "SINGLE": "لدى جهة الاتصال هذه محادثة أخرى مفتوحة #{id}",
      "MULTIPLE": "لدى جهة الاتصال هذه محادثات أخرى مفتوحة ({count})",
      "OPEN": "فتح",
      "SHOW": "عرض"
    },
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. All new messages will show up there. You won't be able to send messages from this conversation anymore.",
    "WEB_WIDGET_OFFLINE_MESSAGE": "Cannot send message because the customer is not online and email continuity is not available.",
    "WEB_WIDGET_OFFLINE_WARNING_MESSAGE": "The customer is not online. They may not receive messages since email continuity is not available.",
    "OPEN_FILE": "Open",
    "DOWNLOAD_ATTACHMENTS": "Download all",
    "DOWNLOAD_ATTACHMENTS_TOOLTIP": "Download all attachments one by one",
    "DOWNLOAD_ATTACHMENTS_AS_ZIP": "Download all as ZIP",
    "ERROR_DOWNLOADING_FILE": "Error downloading file",
    "REQUEST_CONTACT_INFO": {
      "ACTION": "طلب مشاركة رقم هاتف واتساب من العميل",
      "PENDING_ACTION": "طلب معلومات الاتصال معلّق",
      "STATES": {
        "PENDING": "بانتظار معلومات الاتصال",
        "SHARED": "تمت مشاركة رقم الهاتف",
        "IDENTITY_CONFLICT": "رقم الهاتف بحاجة إلى مراجعة"
      }
    },
    "SLA": {
      "BREACHED": "breached"
    },
    "IMAGE_UPLOAD_ERROR": "Unable to upload image, please try again",
    "DRAFT": {
      "FILE_TOO_LARGE": "File '{fileName}' ({fileSize}) is too large for draft storage and will be skipped",
      "ATTACHMENT_SERIALIZATION_FAILED": "Failed to serialize attachment for draft storage",
      "STORAGE_QUOTA_EXCEEDED": "Storage quota exceeded. Draft saved without attachments",
      "SAVE_FAILED_WITHOUT_ATTACHMENTS": "Failed to save draft even without attachments",
      "SAVE_FAILED": "Failed to save conversation draft"
    },
    "COMMENT_TREE": {
      "TITLE": "Comment thread",
      "EMPTY": "No comments to display",
      "VIEW_TREE": "View comment thread"
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "إرسال نص المحادثة",
    "DESC": "إرسال نسخة من نص المحادثة إلى عنوان البريد الإلكتروني المحدد",
    "SUBMIT": "إرسال",
    "CANCEL": "إلغاء",
    "SEND_EMAIL_SUCCESS": "تم إرسال نص المحادثة بنجاح",
    "SEND_EMAIL_ERROR": "حدث خطأ، الرجاء المحاولة مرة أخرى",
    "FORM": {
      "SEND_TO_CONTACT": "إرسال نص المحادثة إلى العميل",
      "SEND_TO_AGENT": "إرسال نص المحادثة إلى وكيل خدمة العملاء المعين",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "إرسال النص إلى عنوان بريد إلكتروني آخر",
      "EMAIL": {
        "PLACEHOLDER": "أدخل عنوان بريد إلكتروني",
        "ERROR": "الرجاء إدخال عنوان بريد إلكتروني صحيح"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "اهلاً 👋، مرحباً بك في {installationName}!",
    "DESCRIPTION": "شكرا للتسجيل. نريدك أن تحصل على أقصى استفادة من {installationName}. إليك بعض الأشياء التي يمكنك القيام بها في {installationName} لجعل التجربة رائعة.",
    "GREETING_MORNING": "👋 صباح الخير، {name}. مرحبا بك في {installationName}.",
    "GREETING_AFTERNOON": "👋 مساء الخير، {name}. مرحبا بك في {installationName}.",
    "GREETING_EVENING": "👋 مساء الخير، {name}. مرحبا بك في {installationName}.",
    "READ_LATEST_UPDATES": "اطلع على آخر التحديثات",
    "ALL_CONVERSATION": {
      "TITLE": "جميع محادثاتك في مكان واحد",
      "DESCRIPTION": "عرض جميع المحادثات من عملائك في لوحة تحكم واحدة. يمكنك تصفية المحادثات حسب القناة الواردة والتسمية والحالة.",
      "NEW_LINK": "انقر هنا لإنشاء صندوق وارد"
    },
    "TEAM_MEMBERS": {
      "TITLE": "قم بدعوة أعضاء فريقك",
      "DESCRIPTION": "عندما تصبح جاهز للتخاطب مع عميلك، احضر زملائك في الفريق لمساعدتك. يمكنك دعوة زملائك في الفريق بإضافة عنوان البريد الإلكتروني الخاص بهم إلى قائمة الوكلاء.",
      "NEW_LINK": "انقر هنا لدعوة عضو في الفريق"
    },
    "LABELS": {
      "TITLE": "تنظيم المحادثات مع التسميات",
      "DESCRIPTION": "التسميات توفر طريقة أسهل لتصنيف محادثتك. إنشاء بعض التسميات مثل #كبار_العملاء، #العملاء_المحتملون الخ، بحيث يمكنك استخدامها في محادثة لاحقا.",
      "NEW_LINK": "انقر هنا لإنشاء وسوم"
    },
    "CANNED_RESPONSES": {
      "TITLE": "إدارة الردود الجاهزة",
      "DESCRIPTION": "الردود المسبقة هي قوالب رد مكتوبة مسبقاً تساعدك على الرد بسرعة على محادثة. يمكن للوكلاء كتابة حرف '/' يتبعه الرمز المختصر لإدراج رد مسبق أثناء محادثة.",
      "NEW_LINK": "انقر هنا لإنشاء استجابة مسبقة"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "الوكيل المكلف",
    "SELF_ASSIGN": "إسناد إلي",
    "TEAM_LABEL": "الفريق المكلف",
    "SELECT": {
      "PLACEHOLDER": "لا شيء"
    },
    "ACCORDION": {
      "CUSTOM_DATA_PROVIDER": "Custom Data",
      "CONTACT_DETAILS": "تفاصيل جهة الاتصال",
      "CONVERSATION_ACTIONS": "إجراءات المحادثة",
      "CONVERSATION_LABELS": "وسوم المحادثة",
      "CONVERSATION_INFO": "معلومات المحادثة",
      "CONTACT_ATTRIBUTES": "سمات جهة الاتصال",
      "PREVIOUS_CONVERSATION": "المحادثات السابقة",
      "MACROS": "ماكروس",
      "SHOPIFY_ORDERS": "Shopify Orders",
      "ORDER_HISTORY": "Order History",
      "RETINO_TICKETS": "Retino Tickets"
    },
    "SHOPIFY": {
      "ORDER_ID": "Order #{id}",
      "ERROR": "Error loading orders",
      "NO_SHOPIFY_ORDERS": "No orders found",
      "FINANCIAL_STATUS": {
        "PENDING": "معلق",
        "AUTHORIZED": "Authorized",
        "PARTIALLY_PAID": "Partially Paid",
        "PAID": "Paid",
        "PARTIALLY_REFUNDED": "Partially Refunded",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Fulfilled",
        "PARTIALLY_FULFILLED": "Partially Fulfilled",
        "UNFULFILLED": "Unfulfilled"
      }
    }
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "إنشاء سمة جديدة",
    "NO_RECORDS_FOUND": "لم يتم العثور على سمات",
    "UPDATE": {
      "SUCCESS": "تم تحديث السمة المخصصة بنجاح",
      "ERROR": "غير قادر على تحديث السمة. الرجاء المحاولة مرة أخرى لاحقاً"
    },
    "ADD": {
      "TITLE": "إضافة",
      "SUCCESS": "تمت إضافة السمة بنجاح",
      "ERROR": "غير قادر على إضافة السمة. الرجاء المحاولة مرة أخرى لاحقاً"
    },
    "DELETE": {
      "SUCCESS": "تم حذف السمة المخصصة بنجاح",
      "ERROR": "غير قادر على حذف السمة. الرجاء المحاولة مرة أخرى لاحقاً"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "أضف سمة",
      "PLACEHOLDER": "البحث عن سمات",
      "NO_RESULT": "لم يتم العثور على سمات"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "من",
    "TO": "إلى",
    "BCC": "نسخة خفية من البريد",
    "CC": "نسخة من البريد",
    "SUBJECT": "الموضوع"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "المشاركة",
    "SIDEBAR_TITLE": "المشاركون في المحادثة",
    "NO_RECORDS_FOUND": "لم يتم العثور على النتائج",
    "ADD_PARTICIPANTS": "اختر المشاركين",
    "REMANING_PARTICIPANTS_TEXT": "+{count} آخرون",
    "REMANING_PARTICIPANT_TEXT": "+{count} أخرى",
    "TOTAL_PARTICIPANTS_TEXT": "{count} شخص مشارك.",
    "TOTAL_PARTICIPANT_TEXT": "{count} شخص مشارك.",
    "NO_PARTICIPANTS_TEXT": "لا أحد يشارك!",
    "WATCH_CONVERSATION": "الانضمام إلى المحادثة",
    "YOU_ARE_WATCHING": "أنت مشترك",
    "API": {
      "ERROR_MESSAGE": "تعذر التحديث، حاول مرة أخرى!",
      "SUCCESS_MESSAGE": "تم تحديث المشاركين!"
    },
    "SEARCH_PLACEHOLDER": "Search"
  },
  "TRANSLATE_MODAL": {
    "TITLE": "عرض المحتوى المترجم",
    "DESC": "يمكنك عرض المحتوى المترجم في كل لغة.",
    "ORIGINAL_CONTENT": "المحتوى الأصلي",
    "TRANSLATED_CONTENT": "المحتوى المترجم",
    "NO_TRANSLATIONS_AVAILABLE": "لا توجد ترجمات لهذا المحتوى"
  },
  "TYPING": {
    "ONE": "{user} is typing",
    "TWO": "{user} and {secondUser} are typing",
    "MULTIPLE": "{user} and {count} others are typing",
    "IMAGE_ALT": "Someone is typing"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Try these prompts"
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Unable to download attachment. Please try again"
  },
  "CONVERSATION_CUSTOM_DATA_PROVIDER": {
    "NO_RECORDS_FOUND": "No data found",
    "LOAD_ERROR": "Unable to load data. Please try again later."
  },
  "CONVERSATION_RETINO_TICKETS": {
    "LOAD_MORE": "Load more",
    "NO_RECORDS_FOUND": "No tickets found",
    "LOAD_ERROR": "Unable to load tickets from {hookName}. Please try again later.",
    "NOT_SEARCHABLE": "Contact email is not set.",
    "TIMES": "&times;"
  },
  "CONVERSATION_ORDER_HISTORY": {
    "LOADING": "Loading...",
    "NO_ORDERS": "No orders found",
    "NOT_AVAILABLE": "Customer data not available",
    "EXPAND": "Open customer profile",
    "MORE_ITEMS": "+ {count} items",
    "EXPEDITION_STATUS": "Expedition status",
    "OPEN_DETAIL": "open detail",
    "COPY_ORDER_ID": "رقم الطلب",
    "EXTERNAL_ID": "المعرف الخارجي",
    "PAYMENT_TYPE": "طريقة الدفع",
    "PAYMENT_DATE": "تاريخ الدفع",
    "DELIVERY_PROVIDER": "شركة التوصيل",
    "EXPECTED_DATE_OF_DELIVERY": "التسليم المتوقع",
    "DATE_OF_DELIVERY": "تم التسليم في",
    "EXPEDITION_DATE": "تاريخ الشحن",
    "INTERNAL_NOTE": "ملاحظة المتجر",
    "PACKAGE_NUMBER": "الطرد"
  },
  "READING": {
    "ONE": "{user} is reading this ticket",
    "TWO": "{user} and {secondUser} are reading this ticket",
    "MULTIPLE": "{user} and {count} others are reading this ticket"
  },
  "MOVE_CONVERSATION": {
    "TITLE": "Move Conversation",
    "DESCRIPTION": "Move this conversation to a different email inbox.",
    "SOURCE": {
      "TITLE": "Conversation",
      "ID_LABEL": "Conversation ID"
    },
    "TARGET": {
      "TITLE": "Destination Inbox",
      "PLACEHOLDER": "Select an email inbox",
      "NO_RESULTS": "No other email inboxes available",
      "ERROR": "Please select a destination inbox"
    },
    "SUBMIT": "Move Conversation",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Conversation moved successfully",
    "ERROR_MESSAGE": "Could not move conversation. Please try again."
  },
  "MERGE": {
    "TITLE": "Merge Conversations",
    "DESCRIPTION": "Merge this conversation with another conversation. All messages from this conversation will be moved to the target conversation, and this conversation will be deleted.",
    "SOURCE": {
      "TITLE": "Source Conversation (will be deleted)",
      "ID_LABEL": "Conversation ID"
    },
    "TARGET": {
      "TITLE": "Target Conversation",
      "PLACEHOLDER": "Type conversation ID to search (e.g., 123)",
      "HELP": "Enter the conversation ID to merge all messages into.",
      "ERROR": "Please select a target conversation"
    },
    "WARNING": "Warning: This action cannot be undone. All messages will be moved to the target conversation and this conversation will be permanently deleted.",
    "SUBMIT": "Merge Conversations",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Conversation merged successfully",
    "ERROR_MESSAGE": "Could not merge conversations. Please check the target conversation and try again.",
    "SEARCH": {
      "NO_RESULTS": "No conversation found with this ID",
      "ERROR_MESSAGE": "Could not search conversations. Please try again."
    },
    "CONFIRM": {
      "TITLE": "Confirm Merge",
      "DESCRIPTION": "Are you sure you want to merge this conversation? This action cannot be undone.",
      "YES": "Yes, Merge",
      "CANCEL": "Cancel"
    }
  }
}
